import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
import { Swipe, SwipeItem } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// main.js引入
import vueHashCalendar from 'vue-hash-calendar';
import 'vue-hash-calendar/lib/vue-hash-calendar.css';
Vue.use(vueHashCalendar);

import '../rem.js';
Vue.use(ElementUI);

// import vueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/css/swiper.css';

// Vue.use(vueAwesomeSwiper);
import vueQr from 'vue-qr';
Vue.use(vueQr);

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
